import { render, staticRenderFns } from "./NolaNovelIntroduction.vue?vue&type=template&id=5275782c&scoped=true"
import script from "./NolaNovelIntroduction.vue?vue&type=script&lang=ts"
export * from "./NolaNovelIntroduction.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelIntroduction.vue?vue&type=style&index=0&id=5275782c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5275782c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5275782c')) {
      api.createRecord('5275782c', component.options)
    } else {
      api.reload('5275782c', component.options)
    }
    module.hot.accept("./NolaNovelIntroduction.vue?vue&type=template&id=5275782c&scoped=true", function () {
      api.rerender('5275782c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/nolaNovel/NolaNovelIntroduction.vue"
export default component.exports